import '../sass/main.scss';
import '../img/favicon.ico';

import 'bootstrap';
import 'reflect-metadata';
import {render} from "react-dom";
import {ToastContainer, toast} from "react-toastify";

import ErrorBoundary from "./_lib/components/ErrorBoundary";
import ProfilePreview from "./_elementos/menu/ProfilePreview";

(async () => {
    const el = document.querySelector<HTMLDivElement>('#profile-preview'),
        elAlert = document.querySelector<HTMLDivElement>('#alert-toast');

    if (el)
        render(<ErrorBoundary><ProfilePreview/></ErrorBoundary>, el);

    const errors: string[] = [],
        success: string[] = [];

    document.querySelectorAll<HTMLDivElement>('.ra-error')
        .forEach(el => errors.push(el.innerHTML));

    document.querySelectorAll<HTMLDivElement>('.ra-success')
        .forEach(el => success.push(el.innerHTML));

    if (elAlert)
        await render(<ToastContainer position="bottom-center"/>, elAlert);

    errors.forEach(m => toast.error(m));
    success.forEach(m => toast.success(m));
})();